import request from "@/utils/request";

export function indexNews(query) {
  return request({
    url: `api/admin/news`,
    method: "get",
    params: { ...query }
  });
}
export function getNews() {
  return request({
    url: `api/admin/news`,
    method: "get"
  });
}
export function showNews(slug, locale) {
  return request({
    url: `api/admin/news/${slug}`,
    method: "get",
    headers: { "X-locale": locale }
  });
}
export function getTags() {
  return request({
    url: `/api/admin/tags`,
    method: "get",
    params: { pagination: "all" }
  });
}

export function storeNews(data) {
  return request({
    url: "api/admin/news",
    method: "post",
    data
  });
}
export function updateNews(data, slug) {
  return request({
    url: `api/admin/news/${slug}`,
    method: "post",
    data
  });
}
export function deleteNews(slug) {
  return request({
    url: `api/admin/news/${slug}`,
    method: "delete"
  });
}
export function getfilterTags() {
  return request({
    url: `api/admin/tags?model=news`,
    method: "get"
  });
}
